import {Component} from '@angular/core';
import {User} from '../../../../models/user.model';
import {UserService} from '../../../../services/users.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SelectItem} from 'primeng/primeng';

@Component({
  providers: [UserService],
  selector: 'app-user-add',
  templateUrl: './users.add.component.html'
})
export class UsersAddComponent {
  public user: User = new User();
  public userRoles: SelectItem[];
  public password = '';
  public passwordRepeat = '';
  public error: string;

  constructor(private _userService: UserService, public router: Router) {
    this.user.name = 'Nieuwe gebruiker';
    this.user.email = 'nieuw@airtotaal.nl';
    this.user.role = 'user';
    this.userRoles = [];
    this.userRoles.push({label: 'Admin', value: 'admin'});
    this.userRoles.push({label: 'User', value: 'user'});
  }

  public saveUser(): void {
    let valid = true;

    if (this.user.email === '') {
      this.error = 'Email is verplicht.';
      valid = false;
    }

    if (this.password === '') {
      this.error = 'Het wachtwoord mag niet leeg zijn.';
      valid = false;
    }

    if (this.password !== this.passwordRepeat) {
      this.error = 'De wachtwoorden komen niet overeen.';
      valid = false;
    }

    if (this.user.name === '') {
      this.error = 'Naam is verplicht.';
      valid = false;
    }

    if (valid) {
      this.user.password = this.password;
      this._userService.create(this.user)
        .subscribe(customer => {
          this.router.navigate(['/users']);
        });
    }
  }

  public cancel(): void {
    this.router.navigate(['/users']);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/users/add/users.add.component.ts